import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { t } from "i18next";
import { database } from "../../config/firebase-config";
import { generateMessage } from "../firebaseMessage";
import { generateID } from "../idGenerator.service";
import api from "../api"

let response = {
  status: null,
  data: null,
  message: "",
};

// export const fetchQuotationAsync = async (uid) => {

//   try {
//     // const querySnapshot = await api.get(`/quotations?createdBy=${uid}`)
//     const querySnapshot = await api.get(`/quotations`)
//     // console.log("querySnapshot", querySnapshot)
//     if (querySnapshot?.data?.status == 200 || querySnapshot?.data?.status == 201) {
//       response = {
//         status: 200,
//         data: querySnapshot?.data?.data,
//       };
//     } else {
//       response = {
//         status: 400,
//         message: t("message_quotations_not_found"),
//       };
//     }
//     return response;

//   } catch (error) {
//     let message = generateMessage(error.code);
//     response = {
//       status: 401,
//       data: null,
//       message: message || error.message,
//     };
//     return response;
//   }

//   // try {
//   //   const quotationRef = collection(database, "quotations");

//   //   const q = query(quotationRef, where("createdBy", "==", String(uid)));

//   //   const querySnapshot = await getDocs(q);

//   //   if (!querySnapshot.empty) {
//   //     const dataArr = [];
//   //     querySnapshot.forEach((doc) => {
//   //       dataArr.push(doc.data());
//   //     });
//   //     response = {
//   //       status: 200,
//   //       data: dataArr,
//   //       message: t("message_quotations_get_success"),
//   //     };
//   //   } else {
//   //     response = {
//   //       status: 400,
//   //       message: t("message_quotations_not_found"),
//   //     };
//   //   }

//   //   return response;
//   // } catch (error) {
//   //   let message = generateMessage(error.code);
//   //   response = {
//   //     status: 401,
//   //     data: null,
//   //     message: message || error.message,
//   //   };
//   //   return response;
//   // }
// };

// export const generateQuotationNoAsync = async (uid) => {
//   const response = await generateID(uid, "Quotation");
//   return response;
// };

// export const createQuotationAsync = async (payload) => {

//   console.log("payload =>", payload);

//   payload.customer = payload?.customer?.id

//   try {
//     const querySnapshot = await api.post(`/quotations`, payload)
//    // console.log("querySnapshot", querySnapshot);
//     if (querySnapshot?.data?.status == 200 || querySnapshot?.data?.status == 201) {
//       response = {
//         status: 200,
//         message: t("message_quotation_new_successful"),
//       };

//     } else {
//       response = {
//         status: 400,
//         message: querySnapshot?.data?.message,
//       };
//     }
//     return response;

//   } catch (error) {
//     let message = generateMessage(error.code);
//     response = {
//       status: 401,
//       data: null,
//       message: message || error.message,
//     };
//     return response;
//   }

//   // try {
//   //   await setDoc(doc(database, "quotations", Number(payload._id).toString()), {
//   //     ...payload,
//   //     createdAt: new Date(),
//   //   });
//   //   response = {
//   //     status: 200,
//   //     message: t("message_quotation_new_successful"),
//   //   };
//   //   return response;
//   // } catch (error) {
//   //   let message = generateMessage(error.code);
//   //   response = {
//   //     status: 401,
//   //     data: null,
//   //     message: message || error.message,
//   //   };
//   //   return response;
//   // }
// };

// export const updateQuotationAsync = async (payload, qid) => {

//   payload.customer = payload.companyName

//   try {
//     const querySnapshot = await api.put(`/quotations/${qid}`, payload)
//     if (querySnapshot?.data?.status == 200 || querySnapshot?.data?.status == 201) {
//       response = {
//         status: 200,
//         message: t("message_quotation_update_successful"),
//       };

//     } else {
//       response = {
//         status: 400,
//         message: t("message_quotations_not_found"),
//       };
//     }
//     return response;

//   } catch (error) {
//     let message = generateMessage(error.code);
//     response = {
//       status: 401,
//       data: null,
//       message: message || error.message,
//     };
//     return response;
//   }

//   // try {
//   //   await updateDoc(doc(database, "quotations", String(id)), {
//   //     ...payload,
//   //     lastModified: new Date(),
//   //   });
//   //   response = {
//   //     status: 200,
//   //     message: t("message_quotation_update_successful"),
//   //   };
//   //   return response;
//   // } catch (error) {
//   //   let message = generateMessage(error.code);
//   //   response = {
//   //     status: 401,
//   //     data: null,
//   //     message: message || error.message,
//   //   };
//   //   return response;
//   // }
// };

// export const fetchQuotationDetailAsync = async (id) => {

//   try {
//     const querySnapshot = await api.get(`/quotations/${id}`)
//     if (querySnapshot?.data?.status == 200 || querySnapshot?.data?.status == 201) {
//       response = {
//         status: 200,
//         data: querySnapshot?.data?.data,
//       }; console.log("payload is", querySnapshot.data)
//     } else {
//       response = {
//         status: 400,
//         message: t("message_quotations_not_found"),
//       };
//     }
//     return response;

//   } catch (error) {
//     let message = generateMessage(error.code);
//     response = {
//       status: 401,
//       data: null,
//       message: message || error.message,
//     };
//     return response;
//   }

//   // try {
//   //   const quotationRef = collection(database, "quotations");

//   //   const docRef = doc(database, "quotations", id);
//   //   const docSnap = await getDoc(docRef);

//   //   if (docSnap.exists()) {
//   //     response = {
//   //       status: 200,
//   //       data: docSnap.data(),
//   //     };
//   //   } else {
//   //     response = {
//   //       status: 401,
//   //       data: null,
//   //       message: "quotation details not found",
//   //     };
//   //   }

//   //   return response;
//   // } catch (error) {
//   //   let message = generateMessage(error.code);
//   //   response = {
//   //     status: 401,
//   //     data: null,
//   //     message: message || error.message,
//   //   };
//   //   return response;
//   // }
// };

// export const deleteQuotationAsync = async (id) => {

//   try {
//     const querySnapshot = await api.delete(`/quotations/${id}`)
//     if (querySnapshot?.data?.status == 200 || querySnapshot?.data?.status == 201) {
//       response = {
//         status: 200,
//         message: t("quotations_deleted_succeful"),
//       };

//     } else {
//       response = {
//         status: 400,
//         message: t("message_quotations_not_found"),
//       };
//     }
//     return response;
//   } catch (error) {
//     let message = generateMessage(error.code);
//     response = {
//       status: 400,
//       data: null,
//       message: message || error.message,
//     };
//     return response;
//   }

//   // try {
//   //   const docRef = doc(database, "quotations", String(id));
//   //   await deleteDoc(docRef);

//   //   response = {
//   //     status: 200,
//   //     message: "quotation deleted succesfully...",
//   //   };

//   //   return response;
//   // } catch (error) {
//   //   let message = generateMessage(error.code);
//   //   response = {
//   //     status: 400,
//   //     data: null,
//   //     message: message || error.message,
//   //   };
//   //   return response;
//   // }
// };

export const fetchQuotationsByRoleAsync = async (uid) => await api.get(`/quotations/assign`).then((res) => res.data).catch((err) => err);

export const fetchQuotationAsync = async (uid) => await api.get(`/quotations`).then((res) => res.data).catch((err) => err);

// export const generateQuotationNoAsync = async (uid) => {
//   const response = await generateID(uid, "Quotation");
//   return response;
// };
export const generateQuotationNoAsync = async (uid) => await api.get(`/quotations/quotationNo/generateQuotationNo`).then((res) => res.data).catch((err) => err);

export const createQuotationAsync = async (payload) => await api.post(`/quotations`, payload).then((res) => res.data).catch((err) => err);

export const updateQuotationAsync = async (payload, qid) => await api.put(`/quotations/${qid}`, payload).then((res) => res.data).catch((err) => err);

export const fetchQuotationDetailAsync = async (id) => await api.get(`/quotations/${id}`).then((res) => res.data).catch((err) => err);

export const deleteQuotationAsync = async (id) => await api.delete(`/quotations/${id}`).then((res) => res.data).catch((err) => err);
